var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0999 0.599805H2.6999C1.51865 0.599805 0.599902 1.5623 0.599902 2.6998V18.0998C0.599902 19.2811 1.51865 20.1998 2.6999 20.1998H18.0999C19.2374 20.1998 20.1999 19.2811 20.1999 18.0998V2.6998C20.1999 1.5623 19.2374 0.599805 18.0999 0.599805ZM17.8374 18.0998H2.9624C2.7874 18.0998 2.6999 18.0123 2.6999 17.8373V2.9623C2.6999 2.83105 2.7874 2.6998 2.9624 2.6998H17.8374C17.9687 2.6998 18.0999 2.83105 18.0999 2.9623V17.8373C18.0999 18.0123 17.9687 18.0998 17.8374 18.0998ZM15.4749 4.7998L9.5249 4.84355C9.21865 4.84355 8.9999 5.0623 8.9999 5.36855V6.5498C8.9999 6.85605 9.21865 7.11855 9.5249 7.0748L12.0624 6.9873L4.93115 14.1186C4.7124 14.3373 4.7124 14.6436 4.93115 14.8623L5.9374 15.8686C6.15615 16.0873 6.4624 16.0873 6.68115 15.8686L13.8124 8.7373L13.7249 11.2748C13.6812 11.5811 13.9437 11.7998 14.2499 11.7998H15.4312C15.7374 11.7998 15.9562 11.5811 15.9562 11.2748L15.9999 5.3248C15.9999 5.0623 15.7374 4.7998 15.4749 4.7998Z",
    fill: "#022131"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.9937a0f682b03fa89cc1ea55b256a899.svg";
export { ForwardRef as ReactComponent };